// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wMX8","content":"styles_content__1w1Nh"};